// extracted by mini-css-extract-plugin
export default {"targetContainer":"Target_targetContainer__fCdJf"};